import ELookupAPIKeys from 'types/backend_models/lookup_status/ELookupAPIKeys';
import ILookupModel from 'types/backend_models/lookup_status/ILookupModel';
import { parseResponse } from '../resCheck';
import { getDataActionConstants } from '../dataActionConstants';
import { AppThunk } from 'redux/reducers/rootReducer';
import { AppDispatch } from 'redux/store';
import { setFetchLookupPending, setFetchLookupSucces, setFetchLookupError } from 'redux/reducers/data_action_reducers/lookup_status/lookupDataReducer';


//fetch lookupdata dynamically from api

export function fetchLookup(lookupAPIKey: ELookupAPIKeys): AppThunk
{
    return (dispatch: AppDispatch) =>
    {
        const constants = getDataActionConstants();
        const requestInit: RequestInit = {
            headers: constants.headers
        }

        dispatch(setFetchLookupPending({ lookupKey: lookupAPIKey }))
        fetch(`${constants.serverRoot}/api/${lookupAPIKey}`, requestInit)
            .then((response: Response) => parseResponse<ILookupModel[]>(response))
            .then(response =>
            {
                if (response.ok) {
                    // cast to correct data type
                    let data = response.json as ILookupModel[];
                    dispatch(setFetchLookupSucces({
                        lookupKey: lookupAPIKey,
                        data: data
                    }));
                } else {
                    throw new Error(response.error);
                }
            })
            .catch((error: Error) =>
            {
                console.error(error.message);
                dispatch(setFetchLookupError(
                    { lookupKey: lookupAPIKey, error: error.message }
                ));
            })
    }
}

/* OLD ACTION CREATORS */

// export function fetchLookupPending(
//     lookupAPIKey: ELookupAPIKeys
// ): TAppActionTypes {
//     return {
//         type: FETCH_LOOKUP_PENDING,
//         lookupAPIKey
//     }
// }
// export function fetchLookupSuccess(
//     lookupAPIKey: ELookupAPIKeys,
//     data: ILookupModel[]
// ): TAppActionTypes {
//     return {
//         type: FETCH_LOOKUP_SUCCESS,
//         lookupAPIKey,
//         data
//     };
// }
// export function fetchLookupError(
//     lookupAPIKey: ELookupAPIKeys,
//     error: string
// ): TAppActionTypes {
//     return {
//         type: FETCH_LOOKUP_ERROR,
//         lookupAPIKey,
//         error
//     }
// }